import React, { useRef } from 'react';
import { motion, useScroll } from 'framer-motion';
import { ArrowButton } from '../ui/ArrowButton';
import { Reveal } from '../ui/Reveal';
import { SectionLabel } from '../ui/SectionLabel';
import { SplitText } from '../ui/SplitText';
import { processSteps } from '../../data/process';
import { EASE_OUT } from '../../utils/motion';
export function ProcessSection() {
  const listRef = useRef<HTMLOListElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: listRef,
    offset: ['start 0.7', 'end 0.6']
  });
  return <section className="bg-paper py-24 lg:py-36" data-id="element-206" data-mp="3u7j9umats4bl">
      <div className="mx-auto grid max-w-[1440px] gap-16 px-5 sm:px-8 lg:grid-cols-12" data-id="element-207" data-mp="3p97z89cphpsb">
        <div className="self-start lg:sticky lg:top-28 lg:col-span-5" data-id="element-208" data-mp="3kay39wj5ql5n">
          <Reveal data-id="element-209" data-mp="3k8leazezfaj3">
            <SectionLabel data-id="element-210" data-mp="3g931ys1887rv">Méthode</SectionLabel>
          </Reveal>
          <h2 className="mt-6 text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-211" data-mp="3g89t9lipj873">
            <SplitText text="Une démarche claire, du diagnostic aux résultats." data-id="element-212" data-mp="3bc2wai8ah71a" />
          </h2>
          <Reveal delay={0.15} data-id="element-213" data-mp="3ob2j9q2rz64p">
            <p className="mt-6 max-w-md text-lg leading-relaxed text-muted" data-id="element-214" data-mp="3t3ly0qd787b3">
              Cinq étapes éprouvées sur des dizaines de missions. Vous savez à chaque instant où nous en sommes et ce
              que cela vous rapporte.
            </p>
            <ArrowButton to="/methode" className="mt-8" data-id="element-215" data-mp="3jeltkrfxgjpi">
              Voir la méthode en détail
            </ArrowButton>
          </Reveal>
        </div>

        <ol ref={listRef} className="relative lg:col-span-7" data-id="element-216" data-mp="fxvku4synsk4">
          <div className="absolute bottom-6 left-[21px] top-6 w-px bg-ink/15" aria-hidden="true" data-id="element-217" data-mp="fv9ci2y8x90u" />
          <motion.div style={{
          scaleY: scrollYProgress
        }} className="absolute bottom-6 left-[21px] top-6 w-px origin-top bg-ink" aria-hidden="true" data-id="element-218" data-mp="1zotl7iioqtf" />
          {processSteps.map((step, i) => <li key={step.title} className="relative pb-14 pl-20 last:pb-0" data-id="element-219" data-mp="2rnfso8sduhz6" data-mpi={i}>
              <motion.span initial={{
            backgroundColor: '#F5F4F0',
            color: '#0E1726'
          }} whileInView={{
            backgroundColor: '#0E1726',
            color: '#FFFFFF'
          }} viewport={{
            margin: '-45% 0px -45% 0px'
          }} transition={{
            duration: 0.25,
            ease: EASE_OUT
          }} className="absolute left-0 top-0 grid h-11 w-11 place-items-center rounded-full border border-ink/20 text-sm font-medium" aria-hidden="true" data-id="element-220" data-mp="x6ocb1hcvh2z">
                {i + 1}
              </motion.span>
              <Reveal data-id="element-221" data-mp="9gbyj9zfiq4h">
                <p className="text-sm text-brass-dark" data-id="element-222" data-mp="9fsf1ou4rtoc">{step.period}</p>
                <h3 className="mt-1 text-2xl font-medium tracking-tight" data-id="element-223" data-mp="4is87bpgimw6">
                  <span className="sr-only" data-id="element-224" data-mp="gx644zpc5hc">Étape {i + 1} : </span>
                  {step.title}
                </h3>
                <p className="mt-3 max-w-xl leading-relaxed text-muted" data-id="element-225" data-mp="1yv0axb80s82i">{step.text}</p>
                <ul className="mt-4 flex flex-wrap gap-2" data-id="element-226" data-mp="1uu6kob73uh6g">
                  {step.deliverables.map(d => <li key={d} className="rounded-md bg-white px-3 py-1.5 text-sm text-ink/80 ring-1 ring-inset ring-ink/10" data-id="element-227" data-mp="3cr0a3ntyuvre">
                      {d}
                    </li>)}
                </ul>
              </Reveal>
            </li>)}
        </ol>
      </div>
    </section>;
}